module.exports = __webpack_public_path__ + "static/img/5.0521c31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/5.png
// module id = k5mL
// module chunks = 0